<div class="m-portlet">
    <div class="m-portlet__body">
        <form [formGroup]="generatorForm" ngxsForm="treatmentstate.generatorForm" ngxsFormDebounce="500" novalidate class="mb-2">
            <div class="d-flex w-100 pb-2">
                <div class="row w-100">
                    <div class="col-lg-4 d-flex">
                        <i
                            ngbTooltip="Število ponovitev"
                            container="body"
                            class="la la-sliders m--font-inverse-light mf-icons mr-2"
                            i18n-ngbTooltip="@@app.treatment.wid.m.term-gen.frequency.tooltip"
                        ></i>
                        <input
                            type="number"
                            name="recurringFrequency"
                            formControlName="recurringFrequency"
                            min="0"
                            class="form-control m-input"
                            [ngClass]="{ 'border-danger border': formControls['recurringFrequency'].errors }"
                        />
                    </div>
                    <div class="col-lg-8 d-flex w-100">
                        <i
                            ngbTooltip="Ponavljajoči termin"
                            container="body"
                            class="la la-retweet m--font-inverse-light mf-icons mx-2"
                            i18n-ngbTooltip="@@app.treatment.wid.m.term-gen.type.tooltip"
                        ></i>
                        <select [compareWith]="equalsAnyByReacurring" formControlName="recurringType" class="form-control m-input">
                            <option *ngFor="let reacType of reacurringType" [ngValue]="reacType?.sid">
                                {{ reacType?.name }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="ml-3 d-flex justify-content-end w-100">
                    <button (click)="generateNewTerms()" type="button" class="btn btn-outline-brand m-btn m-btn--pill mr-2">
                        <span>
                            <span>Generiraj</span>
                        </span>
                    </button>

                    <i
                        (click)="onCloseGenerator.emit()"
                        ngbTooltip="Zapri"
                        container="body"
                        class="la mt-2 m--icon-font-size-lg2 mf-cursor-pointer m-btn--hover-danger la-times"
                    ></i>
                </div>
            </div>
            <trt-wid-m-term-base [form]="generatorForm"></trt-wid-m-term-base>
        </form>
    </div>
</div>
